import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import { useAuthContext } from './hooks/useAuthContext'  //nn130
//nn130
// pages & components
import Home from './pages/home/Home'
import Login from './pages/login/Login'
import Signup from './pages/signup/Signup'
import Navbar from './components/Navbar'
// import Reload from './pages/reload/Reload'
import Help from './pages/help/Help'
import Helpbg from './pages/helpbg/Helpbg'

function App() {
  const { user, authIsReady } = useAuthContext()  // nn130,131
  //console.log('userx:',user)

  return (
    <div className="App">
      {authIsReady && (   // nn130
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/"
              element={user ? <Home /> : <Navigate to="/login" />}
            />
            <Route path="/login"
              element={user ? <Navigate to="/" /> : <Login />}
            />
            <Route path="/helpbg"
              element={user ? <Navigate to="/" /> : <Helpbg />}
            />

            <Route path="/signup"
              element={user ? <Navigate to="/" /> : <Signup />}
            />
            {/* <Route path="/reload"
              element={user ? <Reload /> : <Navigate to="/login" />}
            /> */}
            <Route path="/help"
              element={user ? <Help /> : <Navigate to="/login" />}
            />

          </Routes>
        </BrowserRouter>
      )}
    </div>
  );
}

export default App




